// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendor":"a5b82712364892967e5e","styles":"428706ce86e3813d0d98"}[chunkId] + ".css";
};